var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickBuyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8262 1.94716C12.8767 1.54337 12.6549 1.15464 12.2816 0.992606C11.9084 0.830568 11.4729 0.934016 11.2124 1.24663L3.02708 11.069C2.88562 11.2387 2.74234 11.4106 2.63803 11.5616C2.53937 11.7045 2.35924 11.9853 2.35367 12.3544C2.3473 12.777 2.53559 13.179 2.86429 13.4446C3.1514 13.6766 3.48247 13.718 3.65536 13.7337C3.83816 13.7502 4.06191 13.7502 4.28282 13.7501L9.96157 13.7501L9.1737 20.0531C9.12323 20.4569 9.345 20.8456 9.71828 21.0077C10.0916 21.1697 10.527 21.0662 10.7875 20.7536L18.9728 10.9312C19.1143 10.7615 19.2576 10.5897 19.3619 10.4386C19.4605 10.2958 19.6407 10.015 19.6462 9.64586C19.6526 9.22331 19.4643 8.82129 19.1356 8.55568C18.8485 8.32366 18.5174 8.28225 18.3445 8.2666C18.1617 8.25005 17.938 8.25009 17.7171 8.25013L12.0383 8.25013L12.8262 1.94716Z",
    fill: "#9CF9CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickBuyLogo);
export default __webpack_public_path__ + "static/media/quick-buy-logo.ee885ddf160e5f7bf42d5d912e21ba57.svg";
export { ForwardRef as ReactComponent };